import { render, staticRenderFns } from "./userMerge.vue?vue&type=template&id=b15f5d90"
import script from "./userMerge.vue?vue&type=script&lang=js"
export * from "./userMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports